import React, { Component } from 'react'
import { Input, InputNumber, Button, Popconfirm } from 'antd'
import AsyncSelect from 'react-select/lib/Async'

class MaterialRequestLineItem extends Component {
  filterItems = inputValue => {
    const { allItems } = this.props
    return inputValue
      ? allItems.filter(i => i.label.toLowerCase().includes(inputValue.toLowerCase()))
      : allItems
  }

  promiseItemOptions = inputValue =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve(this.filterItems(inputValue))
      }, 1000)
    })

  handleSelectedItem = itemId => {
    const { allItems } = this.props
    const selectedItem =
      itemId && allItems ? allItems.find(option => option.value === itemId) : null
    return selectedItem
  }

  render() {
    const { onItemChange, requestItems } = this.props
    const itemMap =
      requestItems &&
      requestItems.map((item, index) => {
        return (
          <div className="row padding10" key={index}>
            <div className="col-md-3">
              <AsyncSelect
                cacheOptions
                defaultOptions
                loadOptions={this.promiseItemOptions}
                onChange={event => {
                  onItemChange('item_id', event.value, index)
                  onItemChange('name', event.label, index)
                }}
                value={this.handleSelectedItem(item.item_id)}
              />
            </div>
            <div className="col-md-2">
              <InputNumber
                onChange={event => onItemChange('quantity', event, index)}
                value={item.quantity}
              />
            </div>
            <div className="col-md-3">
              <Input
                placeholder="Notes..."
                onChange={event => onItemChange('unit_type', event.target.value, index)}
                value={item.unit_type}
              />
            </div>
            {!this.props.templateManagement && (
              <div className="col-md-2">
                <InputNumber
                  onChange={event => onItemChange('quantity_delivered', event, index)}
                  value={item.quantity_delivered}
                />
              </div>
            )}

            <div className="col-md-2 text-right">
              <div className="materialRequestLineItem">
                <Button icon="caret-up" onClick={() => this.props.moveUp(index)} />
                <Button icon="caret-down" onClick={() => this.props.moveDown(index)} />
                <Popconfirm
                  title="Are you sure you want to delete this line?"
                  onConfirm={() => this.props.deleteItem(index)}
                  onCancel={this.cancelDelete}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button type="danger" icon="delete" />
                </Popconfirm>
              </div>
            </div>
          </div>
        )
      })
    return <div>{itemMap}</div>
  }
}

export default MaterialRequestLineItem



// WEBPACK FOOTER //
// ./src/components/MaterialRequestLineItem.js